import type {FogScene} from "./SoftFogWorkerProtocol.ts";

export function hasAnimatedLights(scene: FogScene): boolean {
    const {transform, stageSize} = scene;
    return (scene.mode === "LIGHTING" || scene.areas.length > 0) && scene.lights.some(light => {
        if (!light.animation || light.animation.strength <= 0 || light.polygon.length < 3) return false;
        const points = light.polygon.map(point => ({
            x: point.x * transform.scale + transform.x, y: point.y * transform.scale + transform.y,
        }));
        return points.some(point => point.x >= 0) && points.some(point => point.x <= stageSize.width)
            && points.some(point => point.y >= 0) && points.some(point => point.y <= stageSize.height);
    });
}

/** Animations are local presentation only; no API writes and no queued frames in hidden tabs. */
export function animateFogLights(scene: FogScene, render: (scene: FogScene) => void): () => void {
    if (!hasAnimatedLights(scene)) return () => {};
    const frameInterval = 1000 / 20;
    let previousTime = performance.now();
    let frame: number;
    const tick = (time: number) => {
        if (!document.hidden && time - previousTime >= frameInterval) {
            previousTime = time - (time - previousTime) % frameInterval;
            render(scene);
        }
        frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
}
